import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SalatiStatusRequest } from './salatistatusrequest';
import { GET } from '../../api';

export class SalatiStatusAPI extends SixdeeCRBTAPI<SalatiStatusRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/salati-status
        return "salati-status"+"?"+"clientTxnId=21042020"+"&"+
        "serviceId=" + this.getRequest().getSalatiStatusRequest().getServiceId() +"&"+
        "activityId="+ this.getRequest().getSalatiStatusRequest().getActivityId() +"&"+
        "aPartyMsisdn=" + this.getRequest().getSalatiStatusRequest().getAPartyMsisdn() +"&"+
        "language="+ this.getRequest().getSalatiStatusRequest().getLanguage();
    }

    /* getRequestData()
    {
        return "clientTxnId=21042020"+"&"+
               "serviceId=" + this.getRequest().getSalatiStatusRequest().getServiceId() +"&"+
               "activityId="+ this.getRequest().getSalatiStatusRequest().getActivityId() +"&"+
               "aPartyMsisdn=" + this.getRequest().getSalatiStatusRequest().getAPartyMsisdn() +"&"+
               "channelId="+ this.getRequest().getSalatiStatusRequest().getChannelId()+"&"+
               "language="+ this.getRequest().getSalatiStatusRequest().getLanguage();
    } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatistatus/salatistatusapi.tsx